(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function initDirectory(root) {
    if (!root || root.dataset.techrefMounted === 'true') return;

    var form = root.querySelector('[data-techref-form]');
    var input = root.querySelector('[data-techref-input]');
    var clearButton = root.querySelector('[data-techref-clear]');
    var resetButton = root.querySelector('[data-techref-reset]');
    var count = root.querySelector('[data-techref-count]');
    var empty = root.querySelector('[data-techref-empty]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-techref-card]'));
    var letterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-techref-letter]'));

    if (!form || !input || !cards.length) return;

    root.dataset.techrefMounted = 'true';
    var activeLetter = 'all';

    function setActiveLetter(nextLetter) {
      activeLetter = String(nextLetter || 'all').toUpperCase();
      if (activeLetter === 'ALL') activeLetter = 'all';

      letterButtons.forEach(function (button) {
        var isActive = button.dataset.techrefLetter === activeLetter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function applyFilters() {
      var query = normalize(input.value);
      var visibleCount = 0;

      cards.forEach(function (card) {
        var brand = normalize(card.dataset.brand);
        var letter = String(card.dataset.letter || '').toUpperCase();
        var matchesQuery = !query || brand.indexOf(query) !== -1;
        var matchesLetter = activeLetter === 'all' || letter === activeLetter;
        var isVisible = matchesQuery && matchesLetter;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (count) count.textContent = String(visibleCount);
      if (empty) empty.hidden = visibleCount !== 0;
      if (clearButton) clearButton.hidden = !query && activeLetter === 'all';
    }

    function resetAll(shouldFocus) {
      input.value = '';
      setActiveLetter('all');
      applyFilters();
      if (shouldFocus) input.focus();
    }

    var availableLetters = new Set(cards.map(function (card) {
      return String(card.dataset.letter || '').toUpperCase();
    }));

    letterButtons.forEach(function (button) {
      var buttonLetter = button.dataset.techrefLetter;
      if (buttonLetter !== 'all' && !availableLetters.has(buttonLetter)) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }

      button.addEventListener('click', function () {
        if (button.disabled) return;
        input.value = '';
        setActiveLetter(buttonLetter);
        applyFilters();
      });
    });

    input.addEventListener('input', function () {
      if (activeLetter !== 'all') setActiveLetter('all');
      applyFilters();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        resetAll(true);
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        resetAll(true);
      });
    }

    applyFilters();
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-technical-references]')) {
      initDirectory(context);
    }
    context.querySelectorAll('[data-technical-references]').forEach(initDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
